enum events {
    LOAD_COPILOT_DRAWER = 'load-copilot-drawer',
    LOAD_COPILOT_MODAL = 'load-copilot-modal',
    SHOW_COPILOT_DRAWER = 'show-copilot-drawer',
    SHOW_COPILOT_MODAL = 'show-copilot-modal',
    HIDE_COPILOT_DRAWER = 'hide-copilot-drawer',
    HIDE_COPILOT_MODAL = 'hide-copilot-modal',
    COPILOT_NEW_SESSION_CREATED = 'copilot-new-session-created',
  }
  
  export default events